import { useEffect } from 'react';
import { callConfig } from '../configs/call';
import { pingCallableUsers } from '../services/call';

const getSafeInterval = (value, fallback) => {
    if (!Number.isFinite(value) || value <= 0) {
        return fallback;
    }
    return value;
};

export const useCallPresenceHeartbeat = (userRoleUuid) => {
    useEffect(() => {
        if (!callConfig.presencePingEnabled || !userRoleUuid) {
            return undefined;
        }

        let isCancelled = false;
        let timer = null;

        const activeInterval = getSafeInterval(callConfig.presencePingIntervalMs, 30000);
        const backgroundInterval = getSafeInterval(
            callConfig.presencePingBackgroundIntervalMs,
            120000
        );

        const runPing = async () => {
            try {
                await pingCallableUsers({ userRoleUuid });
            } catch (error) {
                // Presence ping failure should not block user navigation.
            }
        };

        const schedule = () => {
            if (timer) {
                clearInterval(timer);
            }

            const isBackground = document.visibilityState !== 'visible';
            const intervalMs = isBackground ? backgroundInterval : activeInterval;
            timer = setInterval(() => {
                void runPing();
            }, intervalMs);
        };

        const handleVisibilityChange = () => {
            if (isCancelled) {
                return;
            }
            void runPing();
            schedule();
        };

        void runPing();
        schedule();
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            isCancelled = true;
            if (timer) {
                clearInterval(timer);
            }
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [userRoleUuid]);
};

